import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { CreateOrderFOBActions } from "store/ducks/ordersFob";

export function* createOrderFOBRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/orders-fob/`,
      putData
    );

    const { data } = responseBody;
    yield put(CreateOrderFOBActions.success(data));
    notify("success", "Order FOB criado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateOrderFOBActions.failure(errorMessage));
  }
}
